import {FC, Fragment} from 'react'
import {option} from './NewDataTable'
import {Button} from '../Button/Button'
import {DatatableSub} from '../Datatable/DatatableSub'
import {CellDataTable} from './TableBodyComponents/CellDataTable'
import {CellDataTableSubItem} from './TableBodyComponents/CellDataTableSubItem'
import {OptionsDataTable} from './TableBodyComponents/OptionsDataTable'

type tableBodyProps = {
  copyData: any[]
  extendData?: any
  headers: any[]
  changeItem: (item: any, object: any, value: any) => void
  backgroundRow?: string
  showExtendData: (item: any) => void
  subItems?: any
  perView: number
  indexPagination: number
  options: option[] | undefined
}

const TableBody: FC<tableBodyProps> = ({
  copyData,
  extendData,
  headers,
  changeItem,
  backgroundRow,
  showExtendData,
  subItems,
  perView,
  indexPagination,
  options,
}) => {
  function generateSubitem(
    subitem: any,
    indexSubitem: number,
    textItem: string,
    childrenPosition: number
  ) {
    textItem += `${indexSubitem + 1}.`
    return (
      <>
        <tr className='flex-grow-1 d-flex justify-content-between' key={textItem}>
          {headers.map((object, indexHeader) => (
            <Fragment key={object.value}>
              {object.key !== 'Ações' &&
                object.key !== 'Actions' &&
                object.key !== 'Comportamiento' && (
                  <CellDataTableSubItem
                    object={object}
                    subitem={subitem}
                    childrenPosition={childrenPosition}
                    textItem={textItem}
                    indexHeader={indexHeader}
                  />
                )}
            </Fragment>
          ))}
          {options && options.length > 0 && (
            <td className='d-flex flex-no-wrap w-25 mx-2' style={{minWidth: '10em'}}>
              {options?.map((option, index) => (
                <div
                  className={`d-flex align-items-center me-5 ${
                    option.icon && option.icon.includes('trash')
                      ? 'text-hover-danger'
                      : `${option.icon.includes('eye') ? '' : 'text-hover-primary'}`
                  } cursor-pointer`}
                  key={index}
                  style={{whiteSpace: 'nowrap'}}
                >
                  {option.isButton && (
                    <Button
                      text={option.textButton ?? ''}
                      color={option.color ?? 'primary'}
                      icon={option.icon ?? ''}
                      iconColor={option.iconColor ?? ''}
                      size='small'
                      title={option.title}
                      btnAttr={{
                        type: 'button',
                      }}
                      click={() => option.action && option.action(subitem)}
                      btnClass='py-2 px-3'
                    />
                  )}
                  {!option.isButton && option.icon && (
                    <i
                      title={option.title}
                      className={`${option.icon} fs-4`}
                      onClick={() => option.action && option.action(subitem)}
                    ></i>
                  )}
                  {/* {option.icon && option.icon.includes('plus') && (
                    <i
                      title={option.title}
                      className={`${option.icon} fs-4`}
                      onClick={() => option.action && option.action(item)}
                    ></i>
                  )} */}
                </div>
              ))}
            </td>
          )}
        </tr>
        {subitem.subitems &&
          subitem.subitems.length > 0 &&
          subitem.subitems.map((newSubitem: any, indexSubitemNew: number) =>
            generateSubitem(newSubitem, indexSubitemNew, textItem, childrenPosition + 1)
          )}
      </>
    )
  }

  return (
    <>
      <tbody className='w-100'>
        {copyData.map((item, indexItem) => (
          <>
            <tr
              className='flex-grow-1 d-flex justify-content-between'
              key={indexItem}
              style={
                item.subitems
                  ? {backgroundColor: '#E4EFFB', paddingLeft: 10, paddingRight: 10}
                  : {backgroundColor: backgroundRow ? backgroundRow : 'transparent'}
              }
            >
              {extendData && (
                <td onClick={() => showExtendData(item)} className='cursor-pointer'>
                  <i
                    style={{marginRight: '.4em'}}
                    className={item.extend ? 'fas fa-chevron-down' : 'fas fa-chevron-right'}
                  ></i>
                </td>
              )}

              {subItems && (
                <td onClick={() => showExtendData(item)} className='cursor-pointer'>
                  <i
                    style={{marginRight: '.4em'}}
                    className={item.extend ? 'fas fa-chevron-down' : 'fas fa-chevron-right'}
                  ></i>
                </td>
              )}
              {headers
                .filter((header) => header.show !== false && header.type !== '')
                .map((object, indexHeader) => (
                  <Fragment key={object.value}>
                    <CellDataTable
                      object={object}
                      item={item}
                      indexItem={indexItem}
                      perView={perView}
                      indexPagination={indexPagination}
                      indexHeader={indexHeader}
                      changeItem={changeItem}
                    />
                  </Fragment>
                ))}
              {options && options.length > 0 && <OptionsDataTable options={options} item={item} />}
            </tr>
            {item.subitems &&
              item.subitems.map((subitem: any, indexSubitem: number) =>
                generateSubitem(
                  subitem,
                  indexSubitem,
                  `${indexItem + 1 + Number(perView) * indexPagination}.`,
                  1
                )
              )}
            <tr>
              {extendData && item.extend && item[extendData.value] && (
                <table
                  className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 w-25'
                  style={{minWidth: '10em'}}
                >
                  <thead className='d-flex w-100'>
                    <tr className='flex-grow-1 d-flex justify-content-between fw-bolder text-muted'>
                      {extendData.header.map((header: string, index: number) => (
                        <th className={`mx-0 text-uppercase text-dark px-0`} key={index}>
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className='w-100'>
                    {item[extendData.value] &&
                      item[extendData.value].map((value: any, index: number) => {
                        return (
                          <tr className='flex-grow-1 d-flex justify-content-between' key={index}>
                            {Object.entries(value).map((objectExtend: any, indexObj: number) => (
                              <td
                                className='w-25 mx-2 d-flex align-items-center text-break px-0'
                                key={`obj-${indexObj}`}
                                style={{minWidth: '10em'}}
                              >
                                <span className='text-dark fw-thin'>{objectExtend[1]}</span>
                              </td>
                            ))}
                          </tr>
                        )
                      })}
                  </tbody>
                </table>
              )}
            </tr>
            <tr>
              {subItems && item.extend && item[subItems.value] && (
                <DatatableSub
                  headers={subItems.headers}
                  data={item[subItems.value]}
                  options={subItems.options}
                />
              )}
            </tr>
          </>
        ))}
      </tbody>
    </>
  )
}

export {TableBody}
